<template>
  <div class="shop-the-look__fashions-list">
    <defaultShopTheLook
      :propSettings="settings"
      :mobileSettings="mobileSettings"
      :propPostList="propPostList"
      :lastPage="lastPage"
      :postCount="postCount"
      :popupText="popupText"
    />
  </div>
</template>

<style lang="scss">
.shop-the-look__fashions-list {
  &,
  * {
    box-sizing: border-box;
  }

  .frisbuy-widget {
    .frisbuy-header {
      font-family: inherit;
      color: #2e353b;

      text-align: left;

      margin-left: 17px;

      .frisbuy-title {
        font-size: 26px;
      }

      .frisbuy-subtitle {
        font-size: 16px;

        margin-top: 20px;
      }
    }
  }
}

// media queries
@media (max-width: 390px) {
  .shop-the-look__fashions-list {
    .frisbuy-subtitle {
      display: none;
    }
  }
}
</style>

<script>
import defaultShopTheLook from "../../gallery/gallery.vue";

export default {
  components: { defaultShopTheLook },

  props: {
    propSettings: {
      type: Object,
      required: true,
    },
    mobileSettings: {
      type: Object,
      required: true,
    },
    propPostList: {
      type: Array,
      required: true,
    },
    lastPage: {
      type: Boolean,
      required: true,
    },
    postCount: {
      type: Number,
      required: true,
    },
    popupText: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      settings: this.propSettings || {},
      defaultTitle: "Готовые комплекты",
      defaultSubtitle: "Наводите на товар и переходите в карточку товара",
    };
  },

  created() {
    this.setGalleryHeader();
  },

  methods: {
    setGalleryHeader() {
      this.settings.gallery.header = this.settings.gallery.header || {};

      this.settings.gallery.header.title =
        this.settings.gallery.header.title || this.defaultTitle;

      this.settings.gallery.header.subTitle =
        this.settings.gallery.header.subTitle || this.defaultSubtitle;
    },
  },
};
</script>
